import { MenuCategoryListPage } from "@/features/menu-category/pages/MenuCategoryListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/menu-category/")({
	component: MenuCategoryListPage,
});
